import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

export interface AttestationJustificationHistoryItem {
    justification: string;
    aiDecision?: string;
    cycleStatus?: string;
    attemptedDate?: string;
}

export interface SubmitAttestationRequestDetails {
    servicePrincipalObjectId: string;
    servicePrincipalDisplayName?: string;
    permissionId: string;
    permissionName?: string;
    campaignId: string;
    cycleStatus: string;
    justification?: string;
    isFullCycle: boolean;
    escalationReason?: string;
    previousJustifications?: AttestationJustificationHistoryItem[];
}

@Component({
    selector: 'request-details-attestation-escalation',
    templateUrl: './request-details-attestation-escalation.component.html'
})
export class RequestDetailsAttestationEscalation implements OnInit {

    @Input() requestData: SubmitAttestationRequestDetails;
    @Output() doneLoading = new EventEmitter<boolean>();

    displayObject: any;
    previousJustifications: AttestationJustificationHistoryItem[] = [];

    ngOnInit() {
        this.displayObject = {
            servicePrincipalObjectId: this.requestData?.servicePrincipalObjectId,
            servicePrincipalDisplayName: this.requestData?.servicePrincipalDisplayName ?? '(unknown app)',
            permissionId: this.requestData?.permissionId,
            permissionName: this.requestData?.permissionName ?? this.requestData?.permissionId,
            campaignId: this.requestData?.campaignId,
            cycleStatus: this.requestData?.cycleStatus,
            escalationReason: this.requestData?.escalationReason,
            isFullCycle: this.requestData?.isFullCycle
        };
        this.previousJustifications = this.requestData?.previousJustifications ?? [];
        this.doneLoading.emit(true);
    }
}
